declare global {
  interface Window {
    lintrk: (t: 'track', params: { conversion_id: number }) => void
  }
}

import { isAdvertisingRejected } from 'src/utils/storedCookieConsent'
import { isInternalTraffic } from './internal'

export const getLinkedin = () =>
  typeof window !== 'undefined' && window.lintrk ? window.lintrk : () => {}

/**
 * LinkedIn conversion IDs — set these in LinkedIn Campaign Manager.
 * Each maps to a conversion action configured for the partner ID 7246484.
 * Set to 0 to skip firing for that event.
 */
export const LINKEDIN_CONVERSION_IDS: Record<string, number> = {
  sign_up: 0,
  begin_checkout: 0,
  complete_kyc: 0,
  generate_lead: 23614036,
  purchase: 0,
  // Segmented events — configure IDs in LinkedIn Campaign Manager
  storage_purchase: 25166228,
  storage_complete_kyc: 0,
  parking_monthly_purchase: 25166228,
  parking_monthly_complete_kyc: 24828844,
  parking_b2b_purchase: 25166228,
  parking_b2b_complete_kyc: 24828844,
  parking_b2b_qualified_lead: 24828844,
  parking_b2b_form_submit: 24828844,
  storage_qualified_lead: 0,
  qualified_whatsapp_lead: 0,
  listing_whatsapp_click: 0,
  // Soluciones Logísticas (3PL) — no-op until marketing populates the ID
  logistics_lead: 0,
  logistics_contact_wa: 0,
  // Supply-side (host) conversion IDs — kept at 0 until marketing creates
  // them in LinkedIn Campaign Manager. Once created, paste the IDs here.
  // These are intentionally separate from `generate_lead` (demand) so a
  // LinkedIn supply campaign never optimizes on a renter conversion.
  supply_view: 0,
  supply_lead_start: 0,
  supply_lead: 0,
  supply_lead_individual: 0,
  supply_lead_business: 0,
  supply_lead_traditional: 0,
  supply_lead_calculate: 0,
  supply_lead_broker: 0,
  supply_lead_logistics: 0,
  supply_lead_invite: 0,
  supply_lead_add_post: 0,
  supply_listing_posted: 0,
  host_primary: 0,
  host_secondary: 0
}

export const trackConversion = (event: string): void => {
  if (isInternalTraffic() || isAdvertisingRejected()) return
  const conversionId = LINKEDIN_CONVERSION_IDS[event]
  if (!conversionId) return
  const lintrk = getLinkedin()
  lintrk('track', { conversion_id: conversionId })
}

const linkedin = { getLinkedin, trackConversion }

export default linkedin
